module.exports = __webpack_public_path__ + "img/Smart-Art-Unternehmeneng.a64875c4.png";